<template>
  <span class="go-back">
    <ArrowLeftIcon @click="goBack"/>
  </span>
</template>

<script>
  import { ArrowLeftIcon } from 'vue-feather-icons'
  export default {
    components: { ArrowLeftIcon },
    methods: {
      goBack() {
        this.$router.back()
      }
    },
    name: 'GoBack'

}
</script>

<style scoped>

  .go-back {
    cursor: pointer;
  }

  .go-back svg {
    margin-bottom: 4px;
  }

</style>
